import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import { postData, postFormData, getData } from '../../services/RequestWrapper';

import FamilyInvite from "./FamilyInvite";


function Family() {
	const [family, setFamily] = useState(null);
	const [inviteEmail, setInviteEmail] = useState('');

	useEffect(() => {
		fetchMembers();
	}, []);

	const fetchMembers = async () => {
		const data = await getData('/api/settings/get/family');
		setFamily(data || []);
		console.log(data);
	};

	const handleRemove = async (name, userId) => {
		if (!window.confirm('Вилучити ' + name + ' із сім\'ї?')) return;
		var result = await postFormData('/api/settings/family/remove', { userId });
		result.message && alert(result.message);
		fetchMembers();
	};

	const handleInvite = async (e) => {
		e.preventDefault();
		if (!inviteEmail) return;
		var result = await postFormData('/api/settings/family/invite', { email: inviteEmail });
		result.message && alert(result.message);
		setInviteEmail('');
		fetchMembers();
	};

	return (
		<div>
			<FamilyInvite/>

			{family === null ? (
				<div>Loading...</div>
			) : (
				<ListGroup>
					{family.members.map(member => (
						<ListGroup.Item key={member.userId} className="d-flex align-items-center justify-content-between">
							<div className="d-flex align-items-center">
								<img
									src={member.avatar || '/default-user.png'}
									alt={member.name}
									style={{ width: 40, height: 40, borderRadius: '50%', marginRight: 12 }}
								/>
								<span>{member.name}</span>
								{member.invite === 1 && (<span>⏳</span>)}
								{member.invite === -1 && (<span>🚫</span>)}
								{(member.isOwner) && (<span>💎</span>)}
								
							</div>
							{(family.isOwner || member.isMe) && (<Button variant="outline-danger" size="sm" onClick={() => handleRemove(member.name, member.userId)}>❌</Button>)}
						</ListGroup.Item>
					))}
				</ListGroup>
			)}

			{(family !== null && family.isOwner) && (<>
				<hr/>
				<h6>Запросити до сім'ї</h6>
				<Form onSubmit={handleInvite}>
					<InputGroup>
						<Form.Control
							type="email"
							placeholder="Емейл"
							value={inviteEmail}
							onChange={e => setInviteEmail(e.target.value)}
							required
						/>
						<Button type="submit" variant="primary">
							💌
						</Button>
					</InputGroup>
				</Form>
			</>)}			
		</div>
	);
}

export default Family;